import { Box, Grid, Typography } from "@mui/material";
import { Skeleton as MuiSkeleton, SkeletonProps } from "@mui/lab";
import { times } from "lodash";

import { PanelHeaderBreadcrumb } from "components/PanelHeaderBreadcrumb";
import LeftContent from "components/wrappers/LeftContent";
import Page from "components/wrappers/Page";
import RightContent from "components/wrappers/RightContent";

const Skeleton = (props: SkeletonProps) => (
  <MuiSkeleton variant="rectangular" animation={"wave"} {...props} />
);

const SkeletonDetail = () => {
  return (
    <Box width={1}>
      <Page>
        <LeftContent>
          {times(4, (index) => (
            <Box mb={2} key={index}>
              <Skeleton height={22} />
            </Box>
          ))}
        </LeftContent>
        <RightContent>
          <Box mb={1}>
            <PanelHeaderBreadcrumb
              parent={{ url: "/catalog", label: "Catalog" }}
            />
          </Box>
          <Typography variant="h1">Catalog Panel Detail</Typography>
          <Box bgcolor="#FFF" p={2} mt={2}>
            <Grid container spacing={2}>
              {times(3, (index) => (
                <Grid md={4} item key={index}>
                  <Skeleton height={16} />
                  <Box mt={1}>
                    <Skeleton height={24} />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Box bgcolor="#FFF" p={2} mt={5}>
            <Grid container spacing={2}>
              {times(4, (index) => (
                <Grid md={3} item key={index}>
                  <Skeleton height={90} />
                </Grid>
              ))}
            </Grid>
          </Box>

          <Box mt={5} mb={3}>
            <Skeleton height={35} />
          </Box>

          {times(4, (index) => (
            <Box p={2} bgcolor="#FFF" key={index} mb={index === 3 ? 0 : 5}>
              <Skeleton height={24} />
              <Box pt={3}>
                <Skeleton height={160} />
              </Box>
            </Box>
          ))}
        </RightContent>
      </Page>
    </Box>
  );
};

export default SkeletonDetail;
